// @ts-check


/**
 * @type  { ({key: string, question: string, answer: *})[] }
 */
export const consultInitData = [
    {
      "key": "info_my_name",
      "question" : "1. 기초사항 - 작성자",
      "answer": ""
    },
    {
      "key": "info_my_tel",
      "question" : "1. 기초사항 - 작성자 연락처",
      "answer": ""
    },
    {
      "key": "info_my_birth",
      "question" : "1. 기초사항 - 의뢰인의 생년월일",
      "answer": ""
    },
    {
      "key": "info_my_job",
      "question" : "1. 기초사항 - 의뢰인의 직업",
      "answer": ""
    },
    {
      "key": "info_my_education",
      "question" : "1. 기초사항 - 의뢰인의 최종학력",
      "answer": ""
    },
    {
      "key": "info_my_role",
      "question" : "1. 기초사항 - 의뢰인의 혼인관계",
      "answer": ""
    },
    {
      "key": "info_my_residence",
      "question" : "1. 기초사항 - 의뢰인의 현재 거주지",
      "answer": ""
    },
    {
      "key": "info_spouse_birth",
      "question" : "1. 기초사항 - 상대방의 생년월일",
      "answer": ""
    },
    {
      "key": "info_spouse_job",
      "question" : "1. 기초사항 - 상대방의 직업",
      "answer": ""
    },
    {
      "key": "info_spouse_education",
      "question" : "1. 기초사항 - 상대방의 최종학력",
      "answer": ""
    },
    {
      "key": "info_spouse_role",
      "question" : "1. 기초사항 - 상대방의 혼인관계",
      "answer": ""
    },
    {
      "key": "info_spouse_residence",
      "question" : "1. 기초사항 - 상대방의 현재 거주지",
      "answer": ""
    },
    {
      "key": "info_meet",
      "question" : "1. 기초사항 - 결혼 경위",
      "answer": ""
    },
    {
      "key": "info_living_together",
      "question" : "1. 기초사항 - 동거 기간",
      "answer": ""
    },
    {
      "key": "info_wedding_date",
      "question" : "1. 기초사항 - 결혼식 일자",
      "answer": ""
    },
    {
      "key": "info_registration_date",
      "question" : "1. 기초사항 - 혼인신고 일자",
      "answer": ""
    },
    {
      "key": "info_separation_period",
      "question" : "1. 기초사항 - 별거 기간",
      "answer": ""
    },
    {
      "key": "info_children",
      "question" : "1. 기초사항 - 자녀",
      "answer": ""
    },
    {
      "key": "info_delivery_address",
      "question" : "1. 기초사항 - (의뢰인분이 원고인 경우) 상대방에게 송달을 희망하는 주소지",
      "answer": ""
    },
    {
      "key": "info_intention",
      "question" : "1. 기초사항 - 상대방의 이혼 의사",
      "answer": ""
    },
    {
      "key": "detail_procedure",
      "question" : "2. 혼인에 이르게 된 경위",
      "answer": ""
    },
    {
      "key": "cheating_text",
      "question" : "3. 이혼 사유 가. 재판상 이혼 사유 (1) 상대방의 부정 행위",
      "answer": ""
    },
    {
      "key": "cheating_file",
      "question":"(1) 상대방의 부정 행위 증거자료 파일",
      "answer":[""]
    },
    {
      "key": "abandon_text",
      "question" : "3. 이혼 사유 가. 재판상 이혼 사유 (2) 상대방의 유기 행위",
      "answer": ""
    },
    {
      "key": "abandon_file",
      "question":"(2) 상대방의 유기 행위 증거자료 파일",
      "answer":[""]
    },
    {
      "key": "treatment_me_text",
      "question" : "3. 이혼 사유 가. 재판상 이혼 사유 (3) 상대방 및 상대방 부모님이 나에게 행한 부당대우 증거자료 파일",
      "answer": ""
    },
    {
      "key": "treatment_me_file",
      "question":"(3) 상대방 및 상대방 부모님이 나에게 행한 부당대우 증거자료 파일",
      "answer":[""]
    },
    {
      "key": "treatment_parent_text",
      "question" : "3. 이혼 사유 가. 재판상 이혼 사유 (4) 상대방이 나의 부모님에게 행한 부당대우",
      "answer": ""
    },
    {
      "key": "treatment_parent_file",
      "question":"(4) 상대방이 나의 부모님에게 행한 부당대우 증거자료 파일",
      "answer":[""]
    },
    {
      "key": "etc_text",
      "question" : "3. 이혼 사유 가. 재판상 이혼 사유 (5) 기타 혼인을 계속하기 어려운 중대한 사유",
      "answer": ""
    },
    {
      "key": "etc_file",
      "question":"(5) 기타 혼인을 계속하기 어려운 중대한 사유",
      "answer":[""]
    },
    {
      "key": "current_now",
      "question" : "3. 이혼 사유 나. 현재 혼인관계 상태 (1) 별거 중인지 동거 중인지",
      "answer": ""
    },
    {
      "key": "current_reason",
      "question" : "3. 이혼 사유 나. 현재 혼인관계 상태 (2) 현재 상태에 대한 진술 및 이혼의 계기가 된 결정적인 사건",
      "answer": ""
    },
    {
      "key": "raise_want",
      "question" : "4. 자녀 양육 - 친권 및 양육원자로 지정되시길 원하시나요?",
      "answer": ""
    },
    {
      "key": "raise_childcare",
      "question" : "4. 자녀 양육 - 현재 자녀 양육은 누가 하고 있나요?",
      "answer": ""
    },
    {
      "key": "raise_role",
      "question" : "4. 자녀 양육 - 혼인 생활 중, 자녀 양육에 있어 나와 상대방의 역할은 무엇이었나요?",
      "answer": ""
    },
    {
      "key": "raise_close",
      "question" : "4. 자녀 양육 - 자녀들은 부모 중 누구에게 더 애착을 느끼거나 가깝게 생각하나요?",
      "answer": ""
    },
    {
      "key": "raise_appeal",
      "question" : "4. 자녀 양육 - (친권 양육권 주장을 원하시는 분만) 내가 양육권자가 되어야 하는 이유 및 그간의 양육자로서의 역할을 잘 해온 내용",
      "answer": ""
    },
    {
      "key": "raise_problem",
      "question" : "4. 자녀 양육 - (친권 양육권 주장을 원하시는 분만) 상대방이 양육권자로 지정되면 안 되는 이유 및 그간 상대방이 양육자로서의 역할을 잘 하지 못했다거나 문제가 있었다는 내용",
      "answer": ""
    },
    {
      "key": "realty_my",
      "question": "5. 재산분할 가. 재산상태 (1) 현재 소유 중인 부동산 - 의뢰인",
      "answer": [{
        "kind" : "",
        "address" : "",
        "price" : "",
        "debt" : "",
        "etc" : "",
      }]
    },
    {
      "key": "realty_spouse",
      "question": "5. 재산분할 가. 재산상태 (1) 현재 소유 중인 부동산 - 상대방",
      "answer": [{
        "kind" : "",
        "address" : "",
        "price" : "",
        "debt" : "",
        "etc" : "",
      }]
    },
    {
      "key": "finance_my",
      "question": "5. 재산분할 가. 재산상태 (2) 금융자산 - 의뢰인",
      "answer": [{
        "kind" : "",
        "detail" : "",
      }]
    },
    {
      "key": "finance_spouse",
      "question": "5. 재산분할 가. 재산상태 (2) 금융자산 - 상대방",
      "answer": [{
        "kind" : "",
        "detail" : "",
      }]
    },
    {
      "key": "car_my",
      "question": "5. 재산분할 가. 재산상태 (3) 차량 - 의뢰인",
      "answer": [{
        "number" : "",
        "detail" : "",
      }]
    },
    {
      "key": "car_spouse",
      "question": "5. 재산분할 가. 재산상태 (3) 차량 - 상대방",
      "answer": [{
        "number" : "",
        "detail" : "",
      }]
    },
    {
      "key": "bond_my",
      "question": "5. 재산분할 가. 재산상태 (4) 채권 - 의뢰인",
      "answer": [{
        "kind" : "",
        "detail" : "",
        "evidence" : "",
      }]
    },
    {
      "key": "bond_spouse",
      "question": "5. 재산분할 가. 재산상태 (4) 채권 - 상대방",
      "answer": [{
        "kind" : "",
        "detail" : "",
        "evidence" : "",
      }]
    },
    {
      "key": "debt_my",
      "question": "5. 재산분할 가. 재산상태 (5) 채무 - 의뢰인",
      "answer": [{
        "kind" : "",
        "detail" : "",
        "evidence" : "",
      }]
    },
    {
      "key": "debt_spouse",
      "question": "5. 재산분할 가. 재산상태 (5) 채무 - 상대방",
      "answer": [{
        "kind" : "",
        "detail" : "",
        "evidence" : "",
      }]
    },
    {
      "key": "career_my_income",
      "question" : "5. 재산분할 나. 직업변동 과정 - 의뢰인의 현재 월 수입",
      "answer": ""
    },
    {
      "key": "career_my_detail",
      "question" : "5. 재산분할 나. 직업변동 과정 - 의뢰인의 직업변동 과정",
      "answer": ""
    },
    {
      "key": "career_spouse_income",
      "question" : "5. 재산분할 나. 직업변동 과정 - 상대방의 현재 월 수입",
      "answer": ""
    },
    {
      "key": "career_spouse_detail",
      "question" : "5. 재산분할 나. 직업변동 과정 - 상대방의 직업변동 과정",
      "answer": ""
    },
    {
      "key": "formation_my_property",
      "question" : "5. 재산분할 다. 재산형성 과정 (1) 결혼 당시 의뢰인이 가져온 재산",
      "answer": ""
    },
    {
      "key": "formation_spouse_property",
      "question" : "5. 재산분할 다. 재산형성 과정 (1) 결혼 당시 상대방이 가져온 재산",
      "answer": ""
    },
    {
      "key": "formation_detail",
      "question" : "(2) 결혼 후 재산 형성 과정 및 의뢰인의 기여도에 대하여",
      "answer": ""
    },
    {
      "key": "check_1",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (1) 부동산, 주식, 예금, 보험, 퇴직금 등의 조회를 원하는지",
      "answer": ""
    },
    {
      "key": "check_1_company",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (1) 퇴직금 조회를 원하는 상대방 재직 회사명",
      "answer": ""
    },
    {
      "key": "check_1_address",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (1) 퇴직금 조회를 원하는 상대방 재직 회사 소재지",
      "answer": ""
    },
    {
      "key": "check_2",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (2) 재산명시를 원하는지",
      "answer": ""
    },
    {
      "key": "check_3",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (3) 기타 확인하고 싶은 재산이 있으신지",
      "answer": ""
    },
    {
      "key": "check_3_detail",
      "question" : "5. 재산분할 라. 상대방 재산 조회 원하시는지 여부 (3) 기타 확인하고 싶은 재산 상세 기재",
      "answer": ""
    },
    {
      "key": "sheet_my_property",
      "question": "재산명세표 - 의뢰인의 재산, 재산의 가액(원)",
      "answer": [{
        "kind" : "",
        "amount" : "0",
      }]
    },
    {
      "key": "sheet_my_total_property",
      "question" : "재산명세표 - 의뢰인의 재산 합계(원)",
      "answer": "0"
    },
    {
      "key": "sheet_my_debt",
      "question": "재산명세표 - 의뢰인의 채무, 채무의 가액(원)",
      "answer": [{
        "kind" : "",
        "amount" : "0",
      }]
    },
    {
      "key": "sheet_my_total_debt",
      "question" : "재산명세표 - 의뢰인의 채무 합계(원)",
      "answer": "0"
    },
    {
      "key": "sheet_my_net_property",
      "question" : "재산명세표 - 의뢰인의 순재산(원)",
      "answer": "0"
    },
    {
      "key": "sheet_spouse_property",
      "question": "재산명세표 - 상대방의 재산, 재산의 가액(원)",
      "answer": [{
        "kind" : "",
        "amount" : "0",
      }]
    },
    {
      "key": "sheet_spouse_total_property",
      "question" : "재산명세표 - 상대방의 재산 합계(원)",
      "answer": "0"
    },
    {
      "key": "sheet_spouse_debt",
      "question": "재산명세표 - 상대방의 채무, 채무의 가액(원)",
      "answer": [{
        "kind" : "",
        "amount" : "0",
      }]
    },
    {
      "key": "sheet_spouse_total_debt",
      "question" : "재산명세표 - 상대방의 채무 합계(원)",
      "answer": "0"
    },
    {
      "key": "sheet_spouse_net_property",
      "question" : "재산명세표 - 상대방의 순재산(원)",
      "answer": "0"
    },
    {
      "key": "sheet_couple_net_property",
      "question" : "재산명세표 - 부부 순재산의 합계(원)",
      "answer": "0"
    },
]

// // 참고용 코드로 주석으로 남겨둠. 
// let consultMap = new Map()

// consultMap.set('sheet_couple_net_property', 
// {
//   "key": "sheet_couple_net_property",
//   "question" : "재산명세표 - 부부 순재산의 합계(원)",
//   "answer": "0"
// })

// const consultArrToMap = () => {
//   consultMap = consultInitData.reduce((map, item) => {
//     return map.set(item.key, item)
//   }, new Map())

//   console.info(consultMap)
// }

// consultArrToMap()